import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {BankReceiptEditForm} from "./BankReceiptEditForm";

export const BankReceiptEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props}>
      <BankReceiptEditForm />
    </DefaultEdit>
  );
};
